<template>
  <v-container v-if="profile != null || undefined">
    <v-fab-transition>
      <v-btn
        v-show="!editing"
        class="mt-12"
        color="primary"
        app
        dark
        absolute
        top
        right
        fab
        @click="edit"
      >
        <v-icon>mdi-pencil</v-icon>
      </v-btn>
    </v-fab-transition>
    <v-fab-transition>
      <v-btn
        v-show="editing"
        class="mt-12"
        color="primary"
        :loading="loading"
        dark
        absolute
        top
        right
        fab
        @click="save"
      >
        <v-icon>mdi-content-save</v-icon>
      </v-btn>
    </v-fab-transition>
    <v-fab-transition>
      <v-btn
        v-if="editing"
        class="mt-12"
        style="top: 40px"
        color="primary"
        dark
        absolute
        top
        right
        fab
        @click="cancel"
      >
        <v-icon>mdi-cancel</v-icon>
      </v-btn>
    </v-fab-transition>
    <v-row v-if="!editing">
      <v-col>
        <v-row>
          <v-col cols="12">
            <v-avatar color="grey" size="200" class="mr-2">
              <v-img v-if="profile.photo" lazy-src :src="profile.photo" :alt="profile.firstName" />
              <span v-else class="white--text display-4">
                {{ profile.firstName | initials
                }}{{ profile.lastName | initials }}
              </span>
            </v-avatar>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <div class="display-1">
              {{ profile.firstName }} {{ profile.middleName }}
              {{ profile.lastName }}
            </div>
            <div>
              Aktiv:
              <v-icon class="mt-n2" v-if="!profile.active" color="red">mdi-close-circle</v-icon>
              <v-icon class="mt-n2" v-if="profile.active" color="green">mdi-check-bold</v-icon>
            </div>
            <div v-if="profile.admin">Admin: {{ profile.admin }}</div>
            <div>
              Funktion:
              <v-chip v-if="functionName" small>
                {{
                functionName | capitalize({ onlyFirstLetter: true })
                }}
              </v-chip>
            </div>
            <div>
              Hold:
              <v-chip v-if="profile.class && className" small link :to="`/hold/${className.slug}`">
                {{
                className.name | capitalize({ onlyFirstLetter: true })
                }}
              </v-chip>
            </div>
            <div v-if="profile.cpr">
              CPR:
              {{ profile.cpr }}
              <!-- {{ new Date() | moment("diff", birthdate, "years") }} -->
            </div>
            <div v-if="profile.cpr">
              Alder:
              {{ profile.cpr | ageCPR }} år
              <!-- {{ new Date() | moment("diff", birthdate, "years") }} -->
            </div>
            <div>Tlf.nummer: {{ profile.number | phoneNumber }}</div>
            <div v-if="profile.address">
              Adresse: {{ profile.address.street }}, {{ profile.address.no }},
              {{ profile.address.code }} {{ profile.address.city }}
            </div>

            <div></div>
          </v-col>
        </v-row>
        <v-row v-if="profile.function == '7mzJwXQe4KnKOQ7Gqovb'">
          <v-col>
            <v-tabs v-model="tab" background-color="transparent" grow>
              <v-tab>Fremmøde</v-tab>
              <v-tab>Kommunikation</v-tab>
              <v-tab>Filer</v-tab>
              <v-tab>Kommentarer</v-tab>
              <v-tab>Kort</v-tab>
              <v-tab>Kort</v-tab>
            </v-tabs>

            <v-tabs-items v-model="tab">
              <v-tab-item>
                <v-col cols="12" md="6">
                  <div>I dag:</div>
                  <div>Denne uge:</div>
                  <div>De sidste fire:</div>
                </v-col>
                <v-col cols="12" md="6">
                  <v-card-title>Seneste fem uger</v-card-title>
                  <v-sparkline
                    :value="value"
                    auto-draw
                    smooth
                    stroke-linecap="round"
                    :gradient="gradient"
                  >
                    <template v-slot:label="item">{{ item.value * 20 }}%</template>
                  </v-sparkline>
                </v-col>
              </v-tab-item>
              <v-tab-item>
                <v-timeline>
                  <v-timeline-item>Underviser: OK.</v-timeline-item>
                  <v-timeline-item class="text-right">Elev: Jeg har influenza</v-timeline-item>
                  <v-timeline-item>Underviser: Hvor bliver du af?</v-timeline-item>
                </v-timeline>
              </v-tab-item>
              <v-tab-item>
                <div class="mt-4">
                  <span v-for="i in 6" :key="i" class="mr-2 ma-3 pa-3 grey">
                    <v-icon large dark>mdi-file</v-icon>
                    Fil {{ i }}
                  </span>
                </div>
              </v-tab-item>

              <v-tab-item>
                <div>23/11/2019: Aftale om...</div>
                <div>12/10/2019: Aftale om...</div>
              </v-tab-item>

              <v-tab-item></v-tab-item>

              <v-tab-item>
                <v-card flat></v-card>
              </v-tab-item>
            </v-tabs-items>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row v-if="editing">
      <v-avatar color="grey" size="200" class="mt-6 ml-3">
        <v-img v-if="editUser.photo" lazy-src :src="editUser.photo" :alt="editUser.firstName" />
        <span
          v-else
          class="white--text display-4"
        >{{ editUser.firstName | initials }}{{ editUser.lastName | initials }}</span>
      </v-avatar>
      <ProfilEditForm @cancel="cancel" ref="EditForm" :save="save" edit="true" :newUser="editUser"></ProfilEditForm>
    </v-row>
  </v-container>
</template>



<script>
import { db } from "../main";
import Vue2Filters from "vue2-filters";
import { diff } from "json-diff";

import ProfilEditForm from "@/components/ProfilEditForm.vue";
const moment = require("moment");

export default {
  name: "profil",
  components: {
    ProfilEditForm
  },
  filters: {
    initials: function(value) {
      if (value) {
        let first = value.charAt(0).toUpperCase();
        return first;
      }
    },
    age: function(value) {
      //var test = moment.unix(value);
      var years = moment().diff(moment(value), "years");
      return years;
    },
    ageCPR: function(value) {
      //var test = moment.unix(value);
      //var years = moment().diff(moment(value), "years");
      let dateFromCPR = moment(value.substring(0, 6), "DDMMYY");
      var years = moment().diff(moment(dateFromCPR), "years");

      return years;
    }
  },
  mixins: [Vue2Filters.mixin],
  methods: {
    edit() {
      if (!this.profile.address) {
        //console.log("no address");
        this.profile.address = {};
      } else {
        //console.log("address", this.profile.address);
      }

      this.editUser = JSON.parse(JSON.stringify(this.profile));

      this.editing = true;
    },
    async save() {
      this.loading = true;

      if (this.$refs.EditForm.$refs.form.validate()) {
        if (this.editUser.number) {
          this.editUser.number = parseInt(this.editUser.number.replace(/\s/g, ""));
        }

        try {
          // saving to database
          var result = await db
            .collection("profiles")
            .doc(this.profile.id)
            .set(this.editUser, { merge: true });
          console.log(result);
          // saving to database

          ///////    Log changes
          if (Object.keys(this.changes.data).length !== 0) {
            console.log("changes:", this.changes.data);
            const writeResult = await db
              .collection("changes")
              .add(this.changes);

            console.log("result:", writeResult);
          }
          ///////    Log changes

          //const id = writeResult.id;
        

          this.$store.dispatch("GET_PROFILE", this.$route.params.id);
          this.editing = false;
          this.editUser = null;
          this.loading = false;
          this.$store.dispatch("snackbar", {
            showing: true,
            text: "Profilen er gemt.",
            timeout: 2000,
            color: "success"
          });
        } catch (e) {
          console.log("Noget gik galt...", e);

          this.loading = false;
          this.$store.dispatch("snackbar", {
            showing: true,
            text: "Tjek dine inputs",
            timeout: 2000,
            color: "error"
          });
        }
      } else {
        this.loading = false;
        this.$store.dispatch("snackbar", {
          showing: true,
          text: "Tjek dine input",
          timeout: 2000,
          color: "error"
        });
      }
    },
    cancel() {
      this.editing = false;
      this.editUser = null;
      this.$store.dispatch("snackbar", {
        showing: true,
        text: "Annulleret...",
        timeout: 2000
      });
    },
    thumb(url, suffix) {
      if (url) {
        //   console.log(url);
        if (!suffix) {
          suffix = "_100x100";
        }

        var filename = url
          .substring(url.lastIndexOf("%2F") + 3)
          .split("/")
          .pop()
          .split("?")[0];
        var ext = filename.split(".").pop();
        var name = filename
          .split(".")
          .slice(0, -1)
          .join(".");
        return url.replace(filename, "thumbs%2F" + name + suffix + "." + ext);
      }
    }
  },
  created() {
    this.$store.dispatch("GET_PROFILE", this.$route.params.id);
    this.$store.dispatch("GET_CLASSES");
    this.$store.dispatch("GET_FUNCTIONS");
    this.$store.dispatch("activePersons");
  },
  computed: {
    changes() {
      if (!this.editing) {
        return null;
      }

      let normalised = {
        ...this.editUser,
        number: parseInt(this.editUser.number.replace(/\s/g, ""), 10)
      };

      let dif = diff(this.profile, normalised);

      let changes = null;

      if (typeof dif !== "undefined") {
        changes = dif;
      }

      let data = {
        by: this.$store.getters.user.id,
        document: this.profile.id,

        date: Date(Date.now()),
        data: { ...changes }
      };

      return data;
    },

    profile() {
      return this.$store.state.profile;
    },
    classes() {
      return this.$store.state.classes;
    },

    functions() {
      return this.$store.state.functions;
    },
    functionName() {
      if (this.functions && this.profile.function) {
        let functionName = this.functions.find(obj => {
          return obj.id === this.profile.function;
        });
        return functionName.funktion;
      }
      return null;
    },
    className() {
      if (this.functions && this.classes && this.profile.class) {
        let className = this.classes.find(obj => {
          return obj.id === this.profile.class;
        });
        return className;
      }
      return null;
    }
  },
  data() {
    return {
      gradient: ["green", "green", "yellow", "red", "red"],
      value: [
        Math.round(Math.random() * 5),
        Math.round(Math.random() * 5),
        Math.round(Math.random() * 5),
        Math.round(Math.random() * 5),
        Math.round(Math.random() * 5)
      ],
      editing: false,
      loading: false,
      editUser: {},
      menu: false,
      tab: null,
      items: ["Appetizers", "Entrees", "Deserts", "Cocktails"],
      text:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat."
    };
  },
  beforeDestroy() {
    this.$store.commit("setProfile", null);
  }
};
</script>

<style lang="scss" scoped>
.fab-container {
  position: fixed;
  top: 0;
  right: 0;
}
</style>
